import React from 'react';
import { ListItem, ListItemText, Chip } from '@material-ui/core';
import { useManageContext } from '../../../../../contexts/ManageContext/ManageContext';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useAuthUser } from '../../../../../contexts/AuthProvider/hooks';

const SelectedOrg = () => {
  const { state, dispatch } = useManageContext();
  const { selectedOrgs } = state;
  const { authUser } = useAuthUser();

  return (
    <>
      {selectedOrgs && (
        <ListItem
          button
          onClick={() => {
            dispatch({ type: 'org-selection', data: { visible: true } });
          }}
        >
          <ListItemText>Organizations</ListItemText>
          <Chip
            label={(selectedOrgs && selectedOrgs.length !== 0
              ? selectedOrgs.length
              : authUser.orgs.length
            ).toLocaleString()}
          />
          <ChevronRightIcon />
        </ListItem>
      )}
    </>
  );
};

export default SelectedOrg;
